var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#211F20",
  d: "M11.093 5.754H2.716l3.66-3.66a.756.756 0 0 0 0-1.065.747.747 0 0 0-1.058 0L.376 5.97a.747.747 0 0 0 0 1.058l4.942 4.942a.747.747 0 1 0 1.058-1.057l-3.66-3.66h8.377c.413 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75Z"
})));
export default SvgArrowBack;